<template>
  <div>
    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Referrals ready...</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Referrals</h1>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="dangerColor"
            :textColor="textColor"
            :text="'Referred Customers This Month'"
            :value="pageData.total_referrals_this_month"
            :valueColor="valueColor"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="'blue'"
            :textColor="'white'"
            :text="'Referred Customers This Week'"
            :value="pageData.total_referrals_this_week"
            :valueColor="'white'"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="dangerColor"
            :textColor="textColor"
            :text="'Referred Customers This Year'"
            :value="pageData.total_referrals_this_year"
            :valueColor="valueColor"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="activeColor"
            :textColor="textColor"
            :text="'Referred Customers Today'"
            :value="pageData.total_referrals_today"
            :valueColor="valueColor"
            :cardImg="usersIcon"
          />
        </div>
      </div>

      <div class="form-group">
        <label for="">Select User</label>
        <select
          name=""
          id=""
          class="form-control"
          v-model="user_id"
          @change="getReferrals(1)"
        >
          <option value="" selected>Please Select All Users</option>
          <option :value="item.id" v-for="(item, index) of staffs" :key="index">
            {{ `${item.first_name} ${item.last_name}` }}</option
          >
        </select>
      </div>

      <div class="card">
        <div class="card-body">
          <CDataTable :items="arr" :fields="fields" sorter>
            <template #referral_name="{item}">
              <td>
                {{ `${item.user.first_name} ${item.user.last_name}` }}
              </td>
            </template>
            <template #referral_role="{item}">
              <td>
                {{ item.user.role }}
              </td>
            </template>
            <template #referred_customer_name="{item}">
              <td>
                {{ `${item.referred.first_name} ${item.referred.last_name}` }}
              </td>
            </template>
            <template #referred_profile_status="{item}">
              <td>
                {{ item.referred.profile_status }}
              </td>
            </template>
            <template #action="{item}">
              <td class="table--action-mobile">
                <router-link
                  v-if="permissions.includes('view-customer')"
                  :event="permissions.includes('view-customer') ? 'click' : ''"
                  class="button"
                  :class="
                    permissions.includes('view-customer')
                      ? ''
                      : 'disabled cursor-not-allowed'
                  "
                  :to="{
                    name: 'CustomerComponent',
                    params: { slug: item.referred.id }
                  }"
                >
                  View
                </router-link>
              </td>
            </template>
          </CDataTable>
          <CPagination
            :activePage.sync="next_page"
            :pages="total"
            :onActivePageChange="onPageChange()"
          ></CPagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "../components/CDataTable.vue";
import ApiService from "../services/api.service";
import CPagination from "../components/CPagination.vue";
import CCard from "../components/CCard.vue";
import usersIcon from "@/assets/images/users-avatar.png";

const fields = [
  "referral_name",
  "referral_role",
  "referred_customer_name",
  // "referred_phone_number",
  // "referred_email",
  // "referred_kyc_status",
  "reward_status",
  "status",
  "referred_profile_status",
  "action"
];
export default {
  name: "ReferralsPage",
  props: {
    slug: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      usersIcon,
      activeColor: "#2CB858",
      dangerColor: "#FBC108",
      textColor: "#001833",
      valueColor: "#001833",
      fields,
      pageData: null,
      pageLoading: true,
      arr: [],
      user_id: "",
      next_page: 1,
      total: 1,
      current: 1,
      getStaffLoading: false,
      staffs: []
    };
  },
  components: {
    CDataTable,
    CCard,
    CPagination
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    func() {
      console.log("Here");
    },
    async getReferrals(page) {
      try {
        const res = await ApiService.get(
          `user/referrals?page=${page}&user_id=${this.slug}`
        );

        this.pageData = res.data.data;
        this.arr = this.pageData.referrals.data;
        this.total = this.pageData.referrals.last_page;
        this.current = this.pageData.referrals.current_page;
        this.pageLoading = false;
      } catch (error) {
        this.pageLoading = false;
        console.log(error.response);
      }
    },
    async getStaffs() {
      try {
        this.getStaffLoading = true;
        const response = await ApiService.get("user/staffs");
        this.staffs = response.data.data;
        this.getStaffLoading = false;
      } catch (error) {
        console.log(error);
        this.getStaffLoading = false;
        console.log(error.response);
      }
    },
    onPageChange() {
      console.log(this.next_page);
      if (this.current != this.next_page) {
        this.getReferrals(this.next_page);
      }
    }
  },
  mounted() {
    this.getReferrals(1);
    this.getStaffs();
  }
};
</script>

<style scoped></style>
